import { Organisation } from '~organisations/domain';

import genericAdditionalFields from './additionalOutcomeCaptureFields/generic';
import logo from './images/logo.png';

const auspostConfig: Organisation = {
  logo: logo,
  additionalOutcomeCaptureFields: {
    '1': genericAdditionalFields,
    '3': genericAdditionalFields,
  },
  asyncAdditionalOutcomeCaptureFields: {},
  contactAssessmentForms: {},
};

export default auspostConfig;
